<template>
  <div class="caseExample">
    <div class="banner" :style="`background-image:url(${banner.picUrl})`" @click="goNewPage(banner.connection)" :class="{canClick: banner.connection}">
      <h1>打造智能猪场</h1>
    </div>
    <div class="middle-content">
      <article class="case-box" :class="{canClick: item.caseUrl}" @click="goNewPage(item.caseUrl)" v-for="(item,key) in caseList" :key="key">
        <p class="address">{{item.caseAddress}}</p>

        <div class="flex-box-justify-space-between">
          <section>
            <h1>{{item.caseName}}</h1>
            <p>{{item.caseDetail}}</p>
          </section>
          <section>
            <h1>{{item.caseExplain}}</h1>
            <p>{{item.explainDetail}}</p>
          </section>
        </div>

        <img :src="item.pictureUrl" alt="">
      </article>
      <h1 class="text-c">商业客户</h1>
      <div class="partner-logo">
        <div class="logo" v-for="(item,key) in partnerList" :key="key">
          <i :style="`background-image:url(${item.pictureUrl})`"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSession, setSession } from '@/utils/index'
export default {
  name: 'caseExample',
  data () {
    return {
      banner: {
        picUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
      },
      caseList: [],
      partnerList: []
    }
  },
  mounted () {
    if (!getSession('bannerPic')) {
      this.getBannerPage()
    } else {
      this.banner = getSession('bannerPic').business_case
    }

    this.getCasePage()
    this.getCustomePage()
    this.$scroll.reveal('.banner h1', {
      distance: '50px',
      origin: 'left',
      duration: 1000
    })
  },
  methods: {
    /**
     * 获取 banner 图片
     */
    async getBannerPage () {
      const params = {
        currentPage: 1,
        pageSize: 100
      }
      const res = await this.API.basic.getBannerPage(params) || []
      // eslint-disable-next-line prefer-const
      let arr = {}
      res.data.map(o => {
        this.$set(arr, o.remark, { picUrl: o.pictureUrl, connection: o.connection })
      })
      this.banner = arr.business_case
      setSession('bannerPic', arr)
    },
    /**
     * 商业案例列表
     */
    async getCasePage () {
      const params = {
        currentPage: 1,
        pageSize: 100,
        state: 0
      }
      const res = await this.API.recruit.getCasePage(params)
      this.caseList = res.data || []
    },
    /**
     * 商业伙伴列表
     */
    async getCustomePage () {
      const params = {
        currentPage: 1,
        pageSize: 100,
        sortRule: 0
      }
      const res = await this.API.recruit.getCustomePage(params)
      this.partnerList = res.data || []
    },
    /** 跳转新页面配置链接 */
    goNewPage (url) {
      if (!url) {
        return ''
      }
      window.open(url)
    }
  }
}
</script>
